import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import config from "./config";
import "@/plugins/vee-validate";
import smartlookClient from "smartlook-client";
import CrispChat from "@dansmaculotte/vue-crisp-chat";

// displaying smart look only on production
if (config.showOnProduction()) {
  smartlookClient.init("d6d41ebf2494fabfe24f983d8393911da3a5f07a", { region: "eu" });

  // Crisp chat
  Vue.use(CrispChat, {
    websiteId: "82a69291-2348-44ee-89e8-a2b2814a6a92",
    disabled: false,
    hideOnLoad: true
  });
}

Vue.config.productionTip = false;

require("@/assets/css/shared.scss");
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
